module.exports = __webpack_public_path__ + "static/TradingView-d8095d936a253d9f7f991567dd1a8aa5.png";